module.exports = __webpack_public_path__ + "static/img/8.6c18390.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/20/zh/8.png
// module id = q7X5
// module chunks = 0